import React from 'react';
import { injectIntl } from 'react-intl';

import FormAutocomplete from 'components/forms/FormAutocomplete';

class CmsBackgroundAttachmentSelector extends React.Component {
  render() {
    const {
      intl: { messages },
      getParamValue,
      setParam,
    } = this.props;

    const options = ['scroll', 'fixed'];

    return (
      <FormAutocomplete
        onChange={setParam}
        value={getParamValue('backgroundAttachment')}
        label={messages.background_attachment}
        name="backgroundAttachment"
        options={options.map(option => {
          return { label: option, value: option };
        })}
      />
    );
  }
}

export default injectIntl(CmsBackgroundAttachmentSelector);
